import { render, staticRenderFns } from "./IconSvgPROLEGISBriefings.vue?vue&type=template&id=530b7e41&scoped=true&"
import script from "./IconSvgPROLEGISBriefings.vue?vue&type=script&lang=js&"
export * from "./IconSvgPROLEGISBriefings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b7e41",
  null
  
)

export default component.exports